import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isMobileAny } from '../../utils/device';
import classes from './styles/index.module.scss';

const NotificationCard = ({
	success,
	warning,
	danger,
	content,
	boxy,
	title,
	advancedContent,
	size,
	stretch,
	className,
	contentStart,
	contentClasses,
	dataTestId,
	isRawHtml,
}) => {
	const notificationClasses = classNames(
		classes.notification,
		classes[`notification_${size}`],
		{
			[classes.notification_success]: success === true,
			[classes.notification_warning]: warning === true,
			[classes.notification_danger]: danger === true,
			[classes.notification_boxy]: boxy === true,
			[classes.notification_mobile]: isMobileAny,
			[classes.notification_stretch]: stretch,
			[classes.notification_contentStart]: contentStart,
		},
		className,
	);

	const notificationContentClasses = classNames(classes.notification__content, contentClasses);

	return (
		<div
			className={notificationClasses}
			data-testid={dataTestId}
		>
			<div className={classes.statusAndContent__wrapper}>
				<div className={classes.statusAndContent}>
					<div className={classes.notification__status} />
					<span className={notificationContentClasses}>
						{title && <h3 className={classes.title}>{title}</h3>}
						{!isRawHtml && content}
						{isRawHtml && <span dangerouslySetInnerHTML={{ __html: content }} />}
					</span>
				</div>
			</div>
			{advancedContent()}
		</div>
	);
};

NotificationCard.propTypes = {
	content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	success: PropTypes.bool,
	warning: PropTypes.bool,
	danger: PropTypes.bool,
	boxy: PropTypes.bool,
	size: PropTypes.string,
	advancedContent: PropTypes.func,
	dataTestId: PropTypes.string,
};

NotificationCard.defaultProps = {
	boxy: false,
	size: 'stretch',
	advancedContent: () => {},
	dataTestId: 'notificationCard',
};

export { NotificationCard };
